<template>
  <div class="searchable-ruejai-club-package-list">
    <el-input
      :value="query"
      prefix-icon="el-icon-search"
      class="query-input"
      placeholder="ค้นหา package"
      clearable
      @input="handleChangeQuery"
    ></el-input>
    <div class="list-body">
      <div v-if="noResult" class="empty">{{ emptyText }}</div>
      <ruejai-club-package-selector-option
        v-for="item in selectablePackages"
        :key="item.id"
        v-bind="item"
        :can-select="canSelect"
        class="selected-item"
        @select="handleSelectPackage(item)"
      ></ruejai-club-package-selector-option>
    </div>
    <div :class="loadingClassList" class="loading-indicator">
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Input } from "element-ui";
import RuejaiClubPackageSelectorOption from "./RuejaiClubPackageSelectorOption";

export default {
  components: {
    RuejaiClubPackageSelectorOption,
    "el-input": Input
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    query: {
      type: String,
      default: ""
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    selectablePackages() {
      return this.value;
    },
    canSelect() {
      return !this.disabled;
    },
    noResult() {
      return this.value.length === 0;
    },
    emptyText() {
      if (this.query) {
        return "ไม่พบบริการที่ค้นหา";
      }

      return "ไม่มีบริการ";
    },
    loadingClassList() {
      return this.isLoading ? "active" : null;
    }
  },
  methods: {
    handleSelectPackage(item) {
      this.$emit("select", item);
    },
    handleChangeQuery(value) {
      this.$emit("queryChange", value);
    }
  }
};
</script>

<style lang="scss">
@import "~@/lib/scss/variables";

.searchable-ruejai-club-package-list {
  position: relative;

  border: $border;
  border-radius: $border-radius;

  .el-input__inner {
    border: 0;
    border-bottom: $border;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;

    height: 43px;
    line-height: 43px;
  }

  > .list-body {
    overflow-y: auto;
    height: 500px;
  }

  > .list-body > .empty {
    padding: 20px 0;
    text-align: center;
  }

  .loading-indicator {
    display: none;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 43px;

    border-bottom-right-radius: $border-radius;

    background: rgba(255, 255, 255, 0.7);

    text-align: center;
    padding: $space;

    &.active {
      display: block;
    }
  }
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 51px;
  height: 51px;
  margin: 6px;
  border: 6px solid $primary-color;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: $primary-color transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
